<template>
  <div>
    <el-row :gutter="24">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="8">
        <div class="block">
          <el-image :src="src3" class="img2"></el-image>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="block">
          <br>
          <p style="color: #006cff"><span style="font-size: 30px;font-weight: bold;margin: 8px 10px;">&lt;&lt; WORD转PDF（双层）</span> </p>
          <p style="line-height: 30px">实现将word文件一键自动批量导出成双层PDF文件格式，文件处理流程符合项目文件流程“word转PDF—>PDF转图片—>图片转PDF—>
            PDF做OCR—>合并PDF”。彻底解放双手，提高转换效率，再也不用每一个步骤都盯着屏幕啦！</p>
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>
    <br> <br><br>

    <el-row :gutter="24">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="8">
        <div class="block">
          <br>
          <p style="color: #006cff"><span style="font-size: 30px;font-weight: bold;margin: 8px 10px;">添加印章图片&gt;&gt;</span> </p>
          <p style="line-height: 30px">在wrod页面可一键批量添加印章、签字等电子图片，通过自定义格式，可自主设置印章签字图片的位置、旋转角度，
            确保输出文档符合项目、投标文件要求。从此让添加电子印章不再让您头晕、腰酸手痛！目前此功能支持docx文件。</p>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="block">
          <el-image :src="src4" class="img2" ></el-image>
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>
    <br>

    <el-row :gutter="24">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="16">
        <div class="block">
          <el-image :src="src5" ></el-image>
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Content',
  props: {
    msg: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      src3: require('@/assets//images/top3.png'),
      src4: require('@/assets/images/top4.png'),
      src5: require('@/assets/images/top5.png')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.img2:hover{
  border: 4px #72b1ee solid;
}
.el-row {
  margin-bottom: 10px;
  /*&:last-child {*/
  /*   margin-bottom: 0;*/
  /* }*/
}
.el-col {
  border-radius: 4px;
  text-align: center;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
</style>
